import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { AuthService } from "@auth0/auth0-angular";
import { filter, firstValueFrom, take } from "rxjs";

export const rootGuard: CanActivateFn = async () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  await firstValueFrom(
    auth.isLoading$.pipe(
      filter((loading) => !loading),
      take(1)
    )
  );

  const isAuthenticated = await firstValueFrom(auth.isAuthenticated$.pipe(take(1)));

  if (isAuthenticated) {
    return router.createUrlTree(["/main/projects"]);
  }

  const deniedMessage = sessionStorage.getItem("auth_denied_message");
  sessionStorage.removeItem("auth_denied_message");

  try {
    await firstValueFrom(
      auth.loginWithRedirect({
        authorizationParams: deniedMessage ? ({ access_denied_message: deniedMessage } as any) : undefined,
      })
    );
  } catch {
    // loginWithRedirect failed (e.g. Auth0 unreachable) — allow landing page to render
    return true;
  }
  return false;
};
